import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=7b0ba715&"
import script from "./TicketForm.vue?vue&type=script&lang=ts&"
export * from "./TicketForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports